
<div class="w-full flex flex-col">
    <app-banner_section-type01 [options]="{title:view.page?.content.name ,imageHref:view.imageHref}"></app-banner_section-type01>
    <app-scroller_section-type01></app-scroller_section-type01>
     <div class="w-full mx-auto sm:px-6 pt-8 pb-16 grid md:grid-cols-2 lg:grid-cols-2 gap-y-8 lg:gap-x-8 lg:gap-y-16">
                        <div>

                            <div class="p-4 rounded-3xl">
                                <div class="flex flex-col">
                                    @if (view.site && view.site.profile && view.site.profile.heading) {
                                        @switch (view.site.profile.heading.position) {
                                            @case (1) {
                                            <app-heading_section-type01
                                                [options]="{heading:view.page?.content.name,title:'Discover Your Perfect Getaway with XL Travel',image:'', description:'',swooshAlign: {'margin':''} }"></app-heading_section-type01>
                                            }
                                            @case (2) {
                                            <app-heading_section-type01
                                                [options]="{heading:'',title:'Discover Your Perfect Getaway with XL Travel',image:'', description:''}"></app-heading_section-type01>
                                            }
                                        }
                                    }
                                </div>
                            </div>
                            <div>
                                <!-- <p class="px-4 pb-10 text-justify" [innerHTML]="view.page?.content.rawContent"></p> -->
                                <p class="px-4 pb-10 text-justify" >At XL Travel, we believe that saving money shouldn’t mean compromising on your dream vacation. Our team of leisure experts is dedicated to planning your next adventure, ensuring a stress-free experience from start to finish. With years of industry knowledge and firsthand experience, we provide insights that go beyond what you’ll find online or in travel magazines.</p>
                            </div>
                        </div>
                        <div  class=" w-[100%] ">
                            <iframe width="100%" height="100%" 
                                src="https://www.youtube.com/embed/I59rntLAn4s" 
                                title="YouTube video player" 
                                frameborder="0" 
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                                allowfullscreen>
                            </iframe>
                        </div>
        </div>

    <section class="flex flex-col p-4 md:p-8 lg:p-15">
        <div class="flex lg:flex-row flex-col   md:flex-row justify-center m-auto ">
            <fuse-card class="w-full m-0 md:m-4 lg:m-4 flex flex-col justify-center  bg-white items-center bg-cover bg-no-repeat bg-center dark:bg-slate-800 ">
                <div class="w-full flex justify-center items-center">
                    <div class="flex flex-col justify-center items-center mt-5 sm:pl-5 sm:pr-5 sm:items-center text">
                        @if (view.site && view.site.profile && view.site.profile.heading) {
                        @switch (view.site.profile.heading.position) {
                        @case (1) {
                        <app-heading_section-type01
                            [options]="{heading:'Our Services',title:'We Provide Top-Quality Solutions for You',image:'', description:'',headingStyle: {'text-align': 'center'},swooshAlign: {'margin': 'auto'}}"></app-heading_section-type01>
                        }
                        @case (2) {
                        <app-heading_section-type01
                            [options]="{heading:'Leisure Travel',title:'',image:'assets/xltravel/swoosh-01.svg', description:'',headingStyle: 'text-center text-4xl' ,swooshAlign: 'mx-auto max-w-md w-full'}"></app-heading_section-type01>
                        }
                        }
                        }
                        <p class="text-md max-w-128 text-gray-600 p-2 leading-6 text-center" [innerHTML]="view.page?.content.rawContentShort"></p>
                    </div>
                </div>
            </fuse-card>
            <div class=" w-full pb-4">
                <div class=" items-center justify-center">
                    <div class="flex grid sm:grid-cols-1 md:grid-cols-2 lg:md:grid-cols-2 m-auto justify-between  gap-3 mt-4">
                        <fuse-card class=" flex flex-col p-4" *ngFor="let item of view.metaDataContent | keyvalue">
                            <div class="w-full sm:flex justify-between items-center mb-3">
                                <h2 class="text-xl leading-snug font-extrabold dark:text-white truncate mb-1 sm:mb-0">
                                {{item.key}}
                                </h2>
                            </div>
                            <div class="flex items-center justify-between whitespace-normal">
                                <div class="flex flex-row max-w-md">
                                    <p class="mb-2 text-gray-500 dark:text-white">{{item.value}}</p>
                                </div>
                            </div>
                        </fuse-card>
                    </div>
                </div>
            </div>
        </div>
        
    </section>
 
    <div class="p-4 md:p-8 lg:p-12 xl:p-16">
        <app-counters-type01></app-counters-type01>
    </div>


</div>

    <!-- <div class="w-full pb-10 bg-gray-200">
        <div class="mt-2 w-[90%] rounded-t-lg m-auto z-10 right-0">
                <ul
                    class="flex flex-wrap mt-16 justify-center -mb-px text-sm p-4 font-medium text-center bg-white rounded-t-lg w-full max-w-2xl"
                    id="default-styled-tab"
                    role="tablist"
                > 
                    <li class="z-30 me-2 focus-within:z-10">
                        <button
                            class="inline-block text-black px-5 py-2 hover:bg-primary-100 hover:text-primary-500 rounded-md uppercase transition transition-duration: 500ms [&.active]:text-primary-500 [&.active]:bg-primary-100"
                            id="fights-tab"
                            [class.active]="view.selectedTab === 'flight'"
                            (click)="selectTab('flight')"
                            type="button"
                            role="tab"
                            aria-controls="flights"
                            aria-selected="true"
                        >
                            Flights
                        </button>
                    </li>
                    <li class="me-2">
                        <button
                            class="inline-block text-black px-5 py-2 rounded-md hover:text-primary-500 hover:bg-primary-100 uppercase transition transition-duration: 500ms [&.active]:text-primary-500 [&.active]:bg-primary-100"
                            id="hotels-tab"
                            [class.active]="view.selectedTab === 'hotel'"
                            (click)="selectTab('hotel')"
                            type="button"
                            role="tab"
                            aria-controls="hotels"
                            aria-selected="view.selectedTab === 'hotel'"
                        >
                            Hotels
                        </button>
                    </li>
                    <li class="me-2">
                        <button
                            class="inline-block px-5 py-2 rounded-md hover:text-primary-500 uppercase text-hint"
                            [matTooltip]="'Coming Soon!'"
                            id="transfers-tab"
                            [class.active]="view.selectedTab === 'cruises'"
                            (click)="selectTab('transfer')"
                            type="button"
                            role="tab"
                            aria-controls="transfers"
                            aria-selected="view.selectedTab === 'transfer'"
                            [disabled]="true"
                        >
                            Cruises
                        </button>
                    </li>
                    <li class="me-2">
                        <button
                            class="inline-block px-5 py-2 rounded-md hover:text-primary-500 uppercase text-hint"
                            [matTooltip]="'Coming Soon!'"
                            id="Packages-tab"
                            [class.active]="view.selectedTab === 'Package'"
                            (click)="selectTab('Package')"
                            type="button"
                            role="tab"
                            aria-controls="Packages"
                            aria-selected="view.selectedTab === 'Package'"
                            [disabled]="true"
                        >
                            Packages
                        </button>
                    </li>
                    <li class="me-2">
                        <button
                            class="inline-block px-5 py-2 rounded-md hover:text-primary-500 uppercase text-hint"
                            [matTooltip]="'Coming Soon!'"
                            id="cars-tab"
                            [class.active]="view.selectedTab === 'car'"
                            (click)="selectTab('car')"
                            type="button"
                            role="tab"
                            aria-controls="cars"
                            aria-selected="view.selectedTab === 'car'"
                            [disabled]="true"
                        >
                            Cars
                        </button>
                    </li>
                    <li class="me-2">
                        <button
                            class="inline-block px-5 py-2 rounded-md hover:text-primary-500 uppercase text-hint"
                            [matTooltip]="'Coming Soon!'"
                            id="transfers-tab"
                            [class.active]="view.selectedTab === 'transfer'"
                            (click)="selectTab('transfer')"
                            type="button"
                            role="tab"
                            aria-controls="transfers"
                            aria-selected="view.selectedTab === 'transfer'"
                            [disabled]="true"
                        >
                            Transfers
                        </button>
                    </li>
                 
                </ul>
                <div id="default-styled-tab-content" class="bg-white shadow-2xl rounded-b-xl rounded-tr-xl">
                    @if (view.selectedTab === 'flight') {
                    <div class="md:rounded-lg">
                        <search-widget
                            [panel]="{ type: 'flight' }"
                            (tripChange)="tripChanged($event)"
                            (searchChange)="searchChanged($event)"
                        ></search-widget>
                    </div>
                    } @if (view.selectedTab === 'hotel') {
                    <div class="md:rounded-lg">
                        <search-widget
                            [panel]="{ type: 'stay' }"
                            (tripChange)="tripChanged($event)"
                            (searchChange)="searchChanged($event)"
                        ></search-widget>
                    </div>
                    } @if (view.selectedTab === 'Package') {
                    <div class="md:rounded-lg">
                        <search-widget
                            [panel]="{ type: 'package' }"
                            (tripChange)="tripChanged($event)"
                            (searchChange)="searchChanged($event)"
                        ></search-widget>
                    </div>
                    } @if (view.selectedTab === 'car') {
                    <div class="md:rounded-lg">
                        <search-widget
                            [panel]="{ type: 'car' }"
                            (tripChange)="tripChanged($event)"
                            (searchChange)="searchChanged($event)"
                        ></search-widget>
                    </div>
                    } @if (view.selectedTab === 'transfer') {
                    <div class="md:rounded-lg">
                        <search-widget
                            [panel]="{ type: 'transfer' }"
                            (tripChange)="tripChanged($event)"
                            (searchChange)="searchChanged($event)"
                        ></search-widget>
                    </div>
                    } @if (view.selectedTab === 'activity') {
                    <div class="md:rounded-lg">
                        <search-widget
                            [panel]="{ type: 'activity' }"
                            (tripChange)="tripChanged($event)"
                            (searchChange)="searchChanged($event)"
                        ></search-widget>
                    </div>
                    } @if (view.selectedTab === 'cruise') {
                    <div class="md:rounded-lg">
                        <search-widget
                            [panel]="{ type: 'cruise' }"
                            (tripChange)="tripChanged($event)"
                            (searchChange)="searchChanged($event)"
                        ></search-widget>
                    </div>
                    }
                </div>
            </div>
    </div> -->